import React, { useState } from 'react';
import { X, CalendarClock } from 'lucide-react';
import { istDayKey } from '../../utils/dates';

/**
 * Prompted when a lead is moved to Follow-up: pick the date the lead should be contacted.
 * On that IST calendar day the lead surfaces automatically in Today's Tasks (LeadCallback).
 *
 * The confirmed instant is 09:00 IST on the chosen day — unless the chosen day is today,
 * in which case it is "in a few minutes" so the server-side future-date validation passes
 * and the task shows up immediately.
 */
export default function FollowUpDateModal({ leadName, busy, onConfirm, onClose }) {
  const todayIst = istDayKey(new Date());
  const plusDays = (n) => istDayKey(new Date(Date.now() + n * 86400000));
  const [date, setDate] = useState(plusDays(7));

  const submit = (e) => {
    e.preventDefault();
    if (!date) return;
    const when = date === todayIst
      ? new Date(Date.now() + 10 * 60000)          // later today
      : new Date(`${date}T09:00:00+05:30`);         // 9 AM IST on the chosen day
    onConfirm(when.toISOString());
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <form className="modal" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <div className="modal-header">
          <h2><CalendarClock size={17} style={{ marginRight: 6, verticalAlign: -3 }} />Schedule follow-up</h2>
          <button type="button" className="modal-close" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="modal-body">
          <p className="td-muted" style={{ marginTop: 0, fontSize: '0.85rem' }}>
            When should {leadName || 'this lead'} be contacted? They will appear in
            {' '}<strong>Today's Tasks</strong> on that date.
          </p>
          <div className="form-group">
            <label className="form-label">Follow-up date *</label>
            <input
              className="form-control" type="date" required
              min={todayIst} value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {[['3 days', 3], ['1 week', 7], ['2 weeks', 14], ['1 month', 30]].map(([label, d]) => (
              <button key={d} type="button"
                className={`btn btn-sm ${date === plusDays(d) ? 'btn-primary' : 'btn-outline'}`}
                onClick={() => setDate(plusDays(d))}>
                {label}
              </button>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-outline" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={busy || !date}>
            {busy ? 'Saving…' : 'Move to Follow-up'}
          </button>
        </div>
      </form>
    </div>
  );
}
